
export default function formatPhone(number){
/**Formats 10 digit phone number */
return "("+number.substring(0, 3)+") "+number.substring(3, 6)+"-"+number.substring(6, 10)
}
